import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 31 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 31 30\" id=\"icon-facebook\">\n  <path fill-rule=\"evenodd\" fill=\"rgb(255, 255, 255)\" d=\"M18.908,29.425 C26.980,27.570 31.998,19.614 30.116,11.655 C28.234,3.697 20.164,-1.251 12.092,0.605 C4.019,2.460 -0.999,10.416 0.883,18.375 C2.378,24.695 7.876,29.318 14.443,29.775 L14.443,19.455 L12.500,19.455 L12.500,15.570 L14.416,15.570 L14.416,13.520 C14.416,8.575 19.126,9.076 19.126,9.076 L22.160,9.076 L22.127,12.648 L20.217,12.648 C18.629,12.648 18.902,13.988 18.902,13.988 L18.902,15.570 L22.106,15.570 L21.478,19.460 L18.908,19.460 L18.908,29.425 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/user/icons/svg/facebook.svg
// module id = qduP
// module chunks = 12